import React from 'react'

type Props = {
  children: React.ReactNode
}

export const UserContainer: React.FC<Props> = ({ children }) => {
  return <div className="min-h-screen bg-container-background">{children}</div>
}
